import React from 'react';
import ReactDOM from 'react-dom';
import Footer from './Footer';

const componentElm = typeof document !== 'undefined' && document.getElementById('Footer-component');

if (componentElm) {
    const initialState = window.initialData.Footer;

    ReactDOM.render(
        <Footer {...initialState}/>,
        componentElm
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/index.js